/**
 * Product Video Overlay (Sense theme)
 *
 * - Video thumbnail button click ko capture phase mein intercept karta hai
 * - Image thumbnails ko touch nahi karta
 * - Data: snippets/product-video-overlay.liquid ke JSON se (Shopify CDN mp4)
 * - Tracking: window.dataLayer
 */

(function () {
  'use strict';

  if (window.__pvoInit) return;

  window.__pvoInit = true;

  const CONFIG = {
    thumbnailSelector:
      '.thumbnail-list__item .thumbnail, .deferred-media__poster, .product__modal-opener--video .product__media-toggle',

    dataSelector: 'script[data-pvo-data]',

    maxQuality: 1080,

    maxQualityMobile: 720,

    mobileQuery: '(max-width: 749px)',

    milestones: [25, 50, 75, 100],

    events: {
      play: 'sgu_video_play',

      progress: 'sgu_video_progress',

      watch: 'sgu_video_watch',

      complete: 'sgu_video_complete'
    }
  };

  const ICONS = {
    close:
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>',

    on:
      '<svg class="pvo__ico-on" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0 0 14 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/></svg>',

    off:
      '<svg class="pvo__ico-off" viewBox="0 0 24 24" aria-hidden="true"><path d="M16.5 12A4.5 4.5 0 0 0 14 7.97v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51A8.8 8.8 0 0 0 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3 3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06a8.99 8.99 0 0 0 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3 12 4 9.91 6.09 12 8.18V4z"/></svg>'
  };

  let ui = null;

  const state = {
    open: false,
    data: null,
    mediaId: null,
    trigger: null,
    src: '',
    playSent: false,
    watched: 0,
    last: 0,
    maxPct: 0,
    hit: {},
    historyPushed: false,
    scrubbing: false,
    prevPct: 0
  };

  /* ---------- Data ---------- */

  function getVideoData(mediaId) {
    const scripts = document.querySelectorAll(CONFIG.dataSelector);

    for (const s of scripts) {
      try {
        const json = JSON.parse(s.textContent);

        const v = json.videos && json.videos[mediaId];

        if (v) {
          return Object.assign(
            {
              productId: json.productId,
              productTitle: json.productTitle
            },
            v
          );
        }
      } catch (e) {
        /* invalid JSON ignore */
      }
    }

    return null;
  }

  // li[data-target="sectionId-mediaId"] se numeric media id
  function resolveMediaId(el) {
    const holder = el.closest('[data-target],[data-media-id]');

    const raw = holder
      ? holder.getAttribute('data-target') ||
        holder.getAttribute('data-media-id') ||
        ''
      : '';

    const m = raw.match(/(\d+)$/);

    return m ? m[1] : null;
  }

  function pickSource(sources) {
    if (!sources || !sources.length) return null;

    const small =
      window.matchMedia(CONFIG.mobileQuery).matches ||
      (navigator.connection && navigator.connection.saveData);

    const limit = small
      ? CONFIG.maxQualityMobile
      : CONFIG.maxQuality;

    const q = (s) =>
      Math.min(s.width || 0, s.height || 0) ||
      s.height ||
      0;

    const sorted = sources.slice().sort((a, b) => q(a) - q(b));

    let best = null;

    sorted.forEach((s) => {
      if (q(s) <= limit) best = s;
    });

    return best || sorted[0];
  }

  /* ---------- Tracking ---------- */

  function track(name, extra) {
    const payload = Object.assign(
      {
        event: name,

        video_provider: 'shopify',

        video_id: state.mediaId,

        video_title: state.data && state.data.productTitle,

        product_id: state.data && state.data.productId,

        product_title:
          state.data && state.data.productTitle
      },
      extra || {}
    );

    (window.dataLayer = window.dataLayer || []).push(payload);
  }

  function flushWatch(reason) {
    if (state.watched >= 0.5 && ui) {
      track(CONFIG.events.watch, {
        watch_time_seconds: Math.round(state.watched),

        percent_watched: Math.round(state.maxPct),

        video_duration: Math.round(
          ui.video.duration || 0
        ),

        close_reason: reason,

        watch_type: 'final'
      });
    }

    state.watched = 0;
  }

  function checkMilestones(pct, prev) {
    state.maxPct = Math.max(state.maxPct, pct);

    CONFIG.milestones.forEach((m) => {
      if (prev < m && pct >= m && !state.hit[m]) {
        state.hit[m] = true;

        track(CONFIG.events.progress, {
          percent: m
        });
      }
    });
  }

  /* ---------- UI ---------- */

  function build() {
    if (ui) return ui;

    const root = document.createElement('div');

    root.className = 'pvo';

    root.hidden = true;

    root.setAttribute('role', 'dialog');

    root.setAttribute('aria-modal', 'true');

    root.setAttribute('aria-label', 'Product video');

    root.innerHTML =
      '<div class="pvo__backdrop" data-pvo-close></div>' +

      '<div class="pvo__player">' +

      '<video class="pvo__video" playsinline webkit-playsinline preload="auto"></video>' +

      '<span class="pvo__play" aria-hidden="true"></span>' +

      '<div class="pvo__seek" role="slider" tabindex="0" aria-label="Seek video" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">' +
      '<div class="pvo__seek-track"><span class="pvo__progress"></span></div>' +
      '</div>' +

      '<button type="button" class="pvo__btn pvo__close" aria-label="Close video">' +
      ICONS.close +
      '</button>' +

      '<button type="button" class="pvo__btn pvo__mute" aria-label="Mute video" aria-pressed="false">' +
      ICONS.on +
      ICONS.off +
      '</button>' +

      '</div>';

    document.body.appendChild(root);

    ui = {
      root: root,

      player: root.querySelector('.pvo__player'),

      video: root.querySelector('.pvo__video'),

      close: root.querySelector('.pvo__close'),

      mute: root.querySelector('.pvo__mute'),

      bar: root.querySelector('.pvo__progress'),

      seek: root.querySelector('.pvo__seek')
    };

    bind();

    return ui;
  }

  function syncMute() {
    const muted =
      ui.video.muted ||
      ui.video.volume === 0;

    ui.mute.classList.toggle(
      'is-muted',
      muted
    );

    ui.mute.setAttribute(
      'aria-pressed',
      String(muted)
    );

    ui.mute.setAttribute(
      'aria-label',
      muted
        ? 'Unmute video'
        : 'Mute video'
    );
  }

  function bind() {
    const v = ui.video;

    ui.root.addEventListener('click', (e) => {
      if (e.target.hasAttribute('data-pvo-close')) {
        close('backdrop');
      }
    });

    ui.close.addEventListener('click', () => {
      close('button');
    });

    ui.mute.addEventListener('click', () => {
      if (v.muted) {
        v.muted = false;

        if (v.volume === 0) {
          v.volume = 1;
        }
      } else {
        v.muted = true;
      }
    });

    v.addEventListener('click', () => {
      v.paused
        ? v.play().catch(() => {})
        : v.pause();
    });

    v.addEventListener('volumechange', syncMute);

    v.addEventListener('playing', () => {
      ui.player.classList.remove('is-paused');

      state.last = v.currentTime;

      if (!state.playSent) {
        state.playSent = true;

        state.watchTicks = 0;

        state.completed = false;

        track(CONFIG.events.play, {
          video_duration: Math.round(
            v.duration || 0
          ),

          muted: v.muted
        });
      }
    });

    v.addEventListener('pause', () => {
      if (state.scrubbing) return;
      ui.player.classList.add('is-paused');
    });

    v.addEventListener('seeking', () => {
      if (v.duration) state.prevPct = (v.currentTime / v.duration) * 100;
      state.last = v.currentTime;
    });

    v.addEventListener('timeupdate', () => {
      const t = v.currentTime;

      const d = t - state.last;

      const natural = d > 0 && d < 1.5 && !state.scrubbing;

      if (natural) {
        state.watched += d;
      }

      state.last = t;

      if (v.duration) {
        const pct =
          (t / v.duration) * 100;

        ui.bar.style.width =
          pct + '%';

        ui.seek.setAttribute('aria-valuenow', String(Math.round(pct)));

        if (natural) checkMilestones(pct, state.prevPct);

        state.prevPct = pct;
      }
    });

    v.addEventListener('ended', () => {
      if (!state.hit[100]) {
        state.hit[100] = true;

        state.maxPct = 100;

        track(CONFIG.events.progress, { percent: 100 });
      }

      if (!state.completed) {
        state.completed = true;

        track(CONFIG.events.complete, {
          video_duration: Math.round(
            v.duration || 0
          ),

          watch_time_seconds: Math.round(
            state.watched
          )
        });
      }

      ui.player.classList.add('is-paused');
    });

    v.addEventListener('error', () => {
      if (state.open) {
        close('error');
      }
    });

    /* ---- Seek bar (drag / click / keyboard) ---- */
    let wasPlaying = false;

    function seekTo(clientX) {
      if (!v.duration) return;

      const r = ui.seek.getBoundingClientRect();

      const p = Math.min(1, Math.max(0, (clientX - r.left) / r.width));

      v.currentTime = p * v.duration;

      ui.bar.style.width = p * 100 + '%';
    }

    ui.seek.addEventListener('pointerdown', (e) => {
      if (!v.duration) return;

      e.preventDefault();

      state.scrubbing = true;

      wasPlaying = !v.paused;

      v.pause();

      ui.seek.classList.add('is-scrubbing');

      ui.seek.setPointerCapture(e.pointerId);

      seekTo(e.clientX);
    });

    ui.seek.addEventListener('pointermove', (e) => {
      if (state.scrubbing) seekTo(e.clientX);
    });

    function endScrub(e) {
      if (!state.scrubbing) return;

      state.scrubbing = false;

      ui.seek.classList.remove('is-scrubbing');

      try {
        ui.seek.releasePointerCapture(e.pointerId);
      } catch (_) {}

      state.last = v.currentTime;

      if (wasPlaying) v.play().catch(() => {});
    }

    ui.seek.addEventListener('pointerup', endScrub);

    ui.seek.addEventListener('pointercancel', endScrub);

    ui.seek.addEventListener('keydown', (e) => {
      if (!v.duration) return;

      let t = null;

      if (e.key === 'ArrowRight') t = v.currentTime + 5;
      else if (e.key === 'ArrowLeft') t = v.currentTime - 5;
      else if (e.key === 'Home') t = 0;
      else if (e.key === 'End') t = v.duration;

      if (t === null) return;

      e.preventDefault();

      v.currentTime = Math.min(v.duration, Math.max(0, t));
    });

    document.addEventListener('keydown', (e) => {
      if (!state.open) return;

      if (e.key === 'Escape') {
        e.preventDefault();

        close('escape');

        return;
      }

      if (e.key === 'Tab') {
        const list = [
          ui.close,
          ui.seek,
          ui.mute
        ];

        const i =
          list.indexOf(
            document.activeElement
          );

        e.preventDefault();

        if (i === -1) {
          list[0].focus();
        } else {
          list[
            (i +
              (e.shiftKey
                ? list.length - 1
                : 1)) %
              list.length
          ].focus();
        }
      }
    });
  }

  /* ---------- Browser Back handling ---------- */

  window.addEventListener('popstate', () => {
    if (!state.open || !state.historyPushed) {
      return;
    }

    close('history', true);
  });

  /* ---------- Open / Close ---------- */

  function lockScroll() {
    const sbw =
      window.innerWidth -
      document.documentElement.clientWidth;

    document.documentElement.style.setProperty(
      '--pvo-sbw',
      sbw + 'px'
    );

    document.documentElement.classList.add(
      'pvo-lock'
    );
  }

  function unlockScroll() {
    document.documentElement.classList.remove(
      'pvo-lock'
    );

    document.documentElement.style.removeProperty(
      '--pvo-sbw'
    );
  }

  function open(data, mediaId, trigger) {
    const src = pickSource(data.sources);

    if (!src) return;

    build();

    // Theme ka global helper: gallery ki baaki media pause
    if (
      typeof window.pauseAllMedia ===
      'function'
    ) {
      window.pauseAllMedia();
    }

    Object.assign(state, {
      open: true,
      data: data,
      mediaId: mediaId,
      trigger: trigger,
      src: src.url,
      scrubbing: false,
      prevPct: 0,

      playSent: false,
      watched: 0,
      last: 0,
      maxPct: 0,
      hit: {},

      historyPushed: false
    });

    const v = ui.video;

    ui.bar.style.width = '0';

    ui.seek.setAttribute('aria-valuenow', '0');

    ui.seek.classList.remove('is-scrubbing');

    ui.player.classList.remove(
      'is-paused'
    );

    v.poster = data.poster || '';

    v.muted = false;

    // sound ON by default
    v.volume = 1;

    v.src = src.url;

    syncMute();

    ui.root.hidden = false;

    lockScroll();

    /*
     * Add one temporary browser history entry.
     * This allows the browser Back button to close
     * the overlay instead of leaving the product page.
     */
    history.pushState(
      {
        ...(history.state || {}),
        sguPvoOverlay: true
      },
      '',
      window.location.href
    );

    state.historyPushed = true;

    requestAnimationFrame(() =>
      ui.root.classList.add('is-open')
    );

    ui.close.focus({
      preventScroll: true
    });

    // Click gesture ke andar hi play.
    // Sound block ho to muted fallback.
    const p = v.play();

    if (p && p.catch) {
      p.catch(() => {
        v.muted = true;

        syncMute();

        v.play().catch(() =>
          ui.player.classList.add(
            'is-paused'
          )
        );
      });
    }
  }

  function close(
    reason,
    fromHistory = false
  ) {
    if (!state.open) return;

    const hadHistoryState =
      state.historyPushed;

    state.open = false;

    state.historyPushed = false;

    flushWatch(reason);

    const v = ui.video;

    v.pause();

    v.removeAttribute('src');

    v.load();

    ui.root.classList.remove(
      'is-open'
    );

    ui.root.hidden = true;

    unlockScroll();

    if (
      state.trigger &&
      document.contains(state.trigger)
    ) {
      state.trigger.focus({
        preventScroll: true
      });
    }

    /*
     * If the user closes via X, backdrop,
     * or Escape, remove the temporary
     * history entry.
     *
     * If the user pressed browser Back,
     * popstate already removed it, so
     * history.back() must NOT run again.
     */
    if (
      !fromHistory &&
      hadHistoryState
    ) {
      history.back();
    }
  }

  /* ---------- Intercept (capture phase, theme ke listener se pehle) ---------- */

  document.addEventListener(
    'click',
    (e) => {
      const thumb =
        e.target.closest &&
        e.target.closest(
          CONFIG.thumbnailSelector
        );

      if (!thumb) return;

      // Mobile: thumbnail strip ke tap par overlay nahi,
      // video pehle main grid mein aaye
      if (
        window.matchMedia(
          CONFIG.mobileQuery
        ).matches &&
        thumb.closest(
          '.thumbnail-list__item'
        )
      ) {
        return;
      }

      const mediaId =
        resolveMediaId(thumb);

      if (!mediaId) return;

      const data =
        getVideoData(mediaId);

      if (
        !data ||
        !pickSource(data.sources)
      ) {
        return;
      }

      e.preventDefault();

      e.stopImmediatePropagation();

      open(
        data,
        mediaId,
        thumb
      );
    },
    true
  );

  const onHide = () => {
    if (state.open) {
      flushWatch('page_hidden');
    }
  };

  document.addEventListener(
    'visibilitychange',
    () => {
      if (
        document.visibilityState ===
        'hidden'
      ) {
        onHide();
      }
    }
  );

  window.addEventListener(
    'pagehide',
    onHide
  );

  customElements
    .whenDefined('deferred-media')
    .then(function () {
      const proto =
        customElements.get(
          'deferred-media'
        ).prototype;

      if (proto.__pvoPatched) {
        return;
      }

      proto.__pvoPatched = true;

      const origLoad =
        proto.loadContent;

      proto.loadContent =
        function () {
          if (
            window.matchMedia(
              CONFIG.mobileQuery
            ).matches
          ) {
            return;
          }

          return origLoad.apply(
            this,
            arguments
          );
        };
    });
})();